import { Link } from 'react-router-dom'
import { useLanguage } from '@i18n'
import './PageBreadcrumbs.css'

export interface BreadcrumbItem {
  label: string
  to: string
}

interface PageBreadcrumbsProps {
  backLabel: string
  backText?: string
  backTo: string
  items: BreadcrumbItem[]
}

export const PageBreadcrumbs = ({ backLabel, backText, backTo, items }: PageBreadcrumbsProps) => {
  const { t } = useLanguage()

  return (
    <ds-breadcrumbs class="ds-breadcrumbs page-breadcrumbs" aria-label={t('breadcrumbs.ariaLabel')}>
      <Link to={backTo} aria-label={backLabel}>
        {backText || (items.length > 1 ? items[items.length - 2].label : items[0]?.label || t('breadcrumbs.back'))}
      </Link>
      <ol>
        {items.map((item) => (
          <li key={`${item.to}-${item.label}`}>
            <Link to={item.to}>{item.label}</Link>
          </li>
        ))}
      </ol>
    </ds-breadcrumbs>
  )
}
